//====== SPACING VARIABLES ======//
export const xs_space = "8px";
export const small_space = "16px";
export const medium_space_1 = "24px";
export const medium_space_2 = "32px";
export const medium_space_3 = "40px";
export const large_space = "56px";
export const xl_space = "80px";
